import styled from 'styled-components';

export const TableWrapper = styled.div`
  position: relative;
  height: 500px;
  overflow-y: auto;

  .ant-table-thead > tr > th {
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
    background: #f6f6f6 !important;
    color: rgba(41, 45, 50, 0.75) !important;
    font-size: 14px;
    font-weight: normal;
    opacity: 1 !important;
  }

  .ant-table-thead > tr {
    height: 50px !important;
  }

  .ant-table-tbody > tr > td {
    color: #292d32 !important;
    font-weight: normal;
  }

  .ant-table-cell-ellipsis {
    padding-left: 24px !important;
  }

  .ant-table {
    .ant-table-cell {
      border-bottom: 1px solid rgba(70, 106, 251, 0.12);
    }
  }
`;

export const LoadingIndicator = styled.div`
  text-align: center;
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50px;
`;

export const EditDeleteIcon = styled.img`
  cursor: pointer;
  width: 24px;
  height: 24px;
`;
